var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success","outlined":""},on:{"click":function () { return _vm.action(_vm.artifacts); }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-check")]),_vm._v(" Submit ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }